import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/social-hub'),
    component: () => import('./SocialHubLayout.vue'),
    children: [
      {
        path: '',
        name: 'social_hub_entry',
        meta: { permissions: ['administrator', 'agent'] },
        component: () => import('./pages/SocialHubEntryPage.vue'),
      },
      {
        path: 'video-studio',
        name: 'social_hub_video_studio',
        meta: { permissions: ['administrator', 'agent'] },
        component: () => import('./pages/VideoStudioPage.vue'),
      },
      {
        path: 'video-trial',
        name: 'social_hub_video_trial',
        meta: { permissions: ['administrator', 'agent'] },
        component: () => import('./pages/VideoTrialPage.vue'),
      },
      {
        path: 'video-basic',
        name: 'social_hub_video_basic',
        meta: { permissions: ['administrator', 'agent'] },
        component: () => import('./pages/VideoBasicPage.vue'),
      },
      {
        path: 'video-ilimitado',
        name: 'social_hub_video_ilimitado',
        meta: { permissions: ['administrator', 'agent'] },
        component: () => import('./pages/VideoIlimitadoPage.vue'),
      },
      {
        path: 'instagram-automations',
        name: 'social_hub_instagram_automations',
        meta: { permissions: ['administrator'] },
        component: () => import('./pages/InstagramAutomationsPage.vue'),
      },
    ],
  },
];
